// ============================================================================
// CASE ADVOCATE SERVICE — Phase 9b-2
// ============================================================================

import { get, post, put, del } from '../client/axiosClient';
import { caseAdvocateEndpoints } from '../endpoints/caseAdvocate.endpoints';
import type { ApiResponse, EmptyResponse, ID } from '../types';
import type {
  CaseAdvocate,
  CreateCaseAdvocateRequest,
  UpdateCaseAdvocateRequest,
} from '../types/caseAdvocate.types';

class CaseAdvocateService {
  async getByCase(caseId: ID): Promise<ApiResponse<CaseAdvocate[]>> {
    const response = await get<ApiResponse<CaseAdvocate[]>>(
      caseAdvocateEndpoints.byCase(caseId),
    );
    return response.data;
  }

  async getById(id: ID): Promise<ApiResponse<CaseAdvocate>> {
    const response = await get<ApiResponse<CaseAdvocate>>(
      caseAdvocateEndpoints.getById(id),
    );
    return response.data;
  }

  async create(data: CreateCaseAdvocateRequest): Promise<ApiResponse<CaseAdvocate>> {
    const response = await post<ApiResponse<CaseAdvocate>>(
      caseAdvocateEndpoints.create(),
      data,
    );
    return response.data;
  }

  async update(id: ID, data: UpdateCaseAdvocateRequest): Promise<ApiResponse<CaseAdvocate>> {
    const response = await put<ApiResponse<CaseAdvocate>>(
      caseAdvocateEndpoints.update(id),
      data,
    );
    return response.data;
  }

  async delete(id: ID): Promise<EmptyResponse> {
    const response = await del<EmptyResponse>(caseAdvocateEndpoints.delete(id));
    return response.data;
  }
}

export const caseAdvocateService = new CaseAdvocateService();
export default caseAdvocateService;
